module.exports = __webpack_public_path__ + "img/line nav.e4691e4d.svg";